const accessControl = {
  pageTitle: 'التحكم بالوصول',
  pageSubtitle: 'إدارة حسابات المستخدمين والأدوار وصلاحيات الوصول عبر المنصة',
  totalUsers: 'إجمالي المستخدمين',
  activeUsers: 'المستخدمين النشطين',
  pendingUsers: 'المستخدمين المعلقين',
  inactiveUsers: 'المستخدمين غير النشطين',
  userName: 'اسم المستخدم',
  email: 'البريد الإلكتروني',
  phone: 'الهاتف',
  role: 'الدور',
  lastLogin: 'آخر تسجيل دخول',
  created: 'تاريخ الإنشاء',
  noUsersFound: 'لم يتم العثور على مستخدمين مطابقين لبحثك.',
  tryAdjustingFilters: 'حاول تعديل البحث أو عوامل التصفية.',
  usersCount: 'مستخدم واحد',
  usersCountPlural: '{{count}} مستخدمين',
  createUser: 'إنشاء مستخدم',
  editRole: 'تعديل الدور',
  resendDetails: 'إعادة إرسال التفاصيل',
  sendDetails: 'إرسال التفاصيل',
  changeRole: 'تغيير الدور',
  saveRole: 'حفظ الدور',
  deactivateUser: 'تعطيل المستخدم',
  activateUser: 'تنشيط المستخدم',
  createUserTitle: 'إنشاء مستخدم جديد',
  createUserSubtitle: 'املأ التفاصيل لإضافة مستخدم جديد إلى المنصة',
  userNamePlaceholder: 'أدخل الاسم الكامل',
  emailPlaceholder: 'أدخل البريد الإلكتروني',
  phonePlaceholder: '+91 XXXXX XXXXX',
  selectRole: 'اختر دوراً',
  autoGeneratedPassword: 'كلمة المرور المُنشأة تلقائياً',
  passwordNote: 'سيتم إنشاء كلمة مرور آمنة تلقائياً. يمكنك مشاركة بيانات الاعتماد مع المستخدم عبر البريد الإلكتروني.',
  createAndSend: 'إنشاء وإرسال التفاصيل',
  createOnly: 'إنشاء المستخدم',
  userCreated: 'تم إنشاء المستخدم بنجاح!',
  userCreatedAndSent: 'تم إنشاء المستخدم وإرسال بيانات الاعتماد عبر البريد الإلكتروني.',
  roleUpdated: 'تم تحديث الدور بنجاح.',
  detailsResent: 'تمت إعادة إرسال بيانات الاعتماد إلى {{email}}.',
  detailsSent: 'تم إرسال بيانات الاعتماد إلى {{email}}.',
  userDeactivated: 'تم تعطيل المستخدم.',
  userActivated: 'تم تنشيط المستخدم.',
  confirmDeactivateTitle: 'تعطيل المستخدم؟',
  confirmDeactivateMessage: 'سيفقد هذا المستخدم الوصول إلى المنصة. يمكنك إعادة تنشيطه لاحقاً.',
  confirmActivateTitle: 'تنشيط المستخدم؟',
  confirmActivateMessage: 'سيؤدي هذا إلى استعادة وصول هذا المستخدم إلى المنصة.',
  confirmResendTitle: 'إعادة إرسال بيانات الاعتماد؟',
  confirmResendMessage: 'سيتم إنشاء كلمة مرور جديدة وإرسال بيانات الاعتماد إلى {{email}} عبر البريد الإلكتروني.',
  searchUsers: 'البحث عن مستخدمين...',
  filterByRole: 'تصفية حسب الدور',
  filterByStatus: 'تصفية حسب الحالة',
  allRoles: 'جميع الأدوار',
  allStatuses: 'جميع الحالات',
  accessControlBreadcrumb: 'التحكم بالوصول',
};

export default accessControl;